import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const wardURL = `api/v1/location-app/ward`;

//obtaining the paginated data
export const getWard = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${wardURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllWard = () => axiosInstance.get(`${wardURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageWard = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${wardURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getWardById = (id) => axiosInstance.get(`${wardURL}/retrieve/${id}`);

//creating function
export const createWard = (body) => axiosInstance.post(`${wardURL}/create`, body);
//updating function
export const updateWard = (id, body) => axiosInstance.patch(`${wardURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${wardURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataWardName = (e, cancelToken) =>
  axiosInstance.get(`${wardURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
